import { type FunctionComponent } from 'react';
import { type Maybe } from '../../../__generated__/graphql-client-types';
import { type BrandInfo, type ProductCollection } from '../../../types/product.types';
import { TextButton } from '../../buttons';
import { StyledLink } from '../../common-components/link/styled-link.component';
import { Modal } from '../../common-components/modal/modal.component';

export type BrandLinksProps = {
	brand: BrandInfo;
	collection?: Maybe<ProductCollection>;
};
export const BrandLinks: FunctionComponent<BrandLinksProps> = ({ brand, collection }) => {
	const { name, url, warrantyText } = brand;
	const listClass = 'mb2';

	return (
		<section>
			<strong>Additional {name} Links</strong>
			<ul>
				{warrantyText && (
					<li className={listClass}>
						<Modal
							triggerElement={
								<TextButton underlineHover={true} textAlign={'tl'}>
									View the Manufacturer Warranty
								</TextButton>
							}
							title={`${name} Warranty`}>
							<p
								dangerouslySetInnerHTML={{
									__html: warrantyText
								}}
							/>
						</Modal>
					</li>
				)}
				{url && (
					<li className={listClass}>
						<StyledLink url={url}>Browse all {name} Products</StyledLink>
					</li>
				)}
				{collection && (
					<li className={listClass}>
						<StyledLink url={collection.url}>
							{name} {collection.name} Collection
						</StyledLink>
					</li>
				)}
			</ul>
		</section>
	);
};
